import reduxStore from 'redux/store'
import {setAlertNotifications} from "../redux/actions";


export const simpleAlert = (confirmText, translateTexts = true, onClose) => alertComplex({confirmText, translateTexts, onClose})
export const alertComplex = ({confirmText, confirmText2, onClose, title, maxWidth, buttonText, translateTexts = true}) => {
    reduxStore.dispatch(setAlertNotifications({
        confirmText,
        confirmText2,
        onClose,
        title,
        maxWidth,
        buttonText,
        translateTexts
    }))
}
